// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"e7ae5df6d8500799","6831":"efe7b5350bf4886c","8503":"c5f81d238a2608d1","9683":"f157f034150852e2"}[chunkId] + ".js";
};